import React, { Component } from "react";
import axios from "../../axios";
import * as url from "../../utils/url";
import Plot from "./../../utils/customPlotly";
import moment from "moment";

class ActionsPieChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pieData: {},
      actionCount: this.props.actionCount,
      isAllEOPage: this.props.eo_id == null ? true : false,
    };

    //  console.log(this.props)
  }
  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.actionCount !== prevProps.actionCount) {
      this.getActionStats();
    }
  }

  componentDidMount() {
    this.getActionStats();
  }

  getActionStats = () => {
    let { isDashboardPage } = this.props;
    // console.log('called!')
    let params = {
      enterpriseId: this.props.eo_id,
    };
    axios
      .get(url.getActionsPieChart, {
        params: params,
      })
      .then((result) => {
        // console.log('data---',  result)
        let pdata = result.data.data;

        if (pdata && pdata.length > 0) {
          let values = pdata.map((e) => e.count);

          let pie_colors = [];

          let labels = pdata.map((e) => {
            if (e._id == 1) {
              pie_colors.push("rgb(233 236 239)");
              return "Not Started";
            } else if (e._id == 2) {
              pie_colors.push("rgb(40 167 69)");
              return "In Progress";
            } else if (e._id == 3) {
              pie_colors.push("rgb(80 153 222)");
              return "Completed";
            }
          });

          let type = "pie";
          this.setState({
            pieData: {
              values,
              labels,
              // pull: [0.2, 0, 0],
              type,
              marker: {
                colors: pie_colors,
                ...(isDashboardPage && {
                  line: {
                    color: "black",
                    width: "1",
                  },
                })
                
              },
              hoverinfo: "label+percent",
              textinfo: "label+percent",
              ...(isDashboardPage
                ? {
                    insidetextorientation: "radial",
                  }
                : {
                    texttemplate:
                      "<b> %{label} </b> <br>" + "%{value} (%{percent})",
                    textposition: "outside",
                  }),

              // texttemplate: "<b> %{label} </b> <br>" +"%{value} (%{percent})",
              // textposition: "outside",
              // insidetextorientation: "radial",
              textfont: {
                family: isDashboardPage ? "Times" : null,
                size: isDashboardPage ? 12 : 12,
                // 'color': ["IndianRed", "MediumPurple", "DarkOrange"]
              },
            },
          });
        } else {
          this.setState({
            pieData: false,
          });
        }
      });
  };

  render() {
    let { pieData, isAllEOPage } = this.state;
    let { isDashboardPage } = this.props;

    if (pieData && Object.keys(pieData).length > 0) {
      return (
        <div>
          <Plot
            data={[pieData]}
            layout={{
              showlegend: false,
              // height:400,
              // width:400,
              // height: 300,
              // width: 200,
              // height:220,
              // width:"100%",
              automargin: true,
              autosize: true,
              // margin: {"t": 40, "b": 30, "l": 80, "r": 80, 'pad':0},
              margin: isDashboardPage
                ? { t: 10, b: 0, l: 0, r: 0, pad: 0 }
                : { t: 40, b: 30, l: 80, r: 80, pad: 0 },
            }}
            scrollZoom={true}
            config={{
              scrollZoom: true,
              modeBarButtonsToAdd: [
                "drawline",
                "drawopenpath",
                "drawclosedpath",
                "drawcircle",
                "drawrect",
                "eraseshape",
              ],
              displaylogo: false,
              responsive: true,
              toImageButtonOptions: {
                format: "png", // one of png, svg, jpeg, webp
                filename: `Pie Chart - ${moment(new Date()).format(
                  "MM-D-YYYY"
                )}`,
                height: 600,
                width: null,
                scale: 1, // Multiply title/legend/axis/canvas sizes by this factor
              },
            }}
            className="plotlyChart"
            // style={{width:'70%'}}
          />
        </div>
      );
    } else if (!pieData) {
      return (
        <span>
          <div
            className={
              isAllEOPage
                ? isDashboardPage
                  ? "mt-5"
                  : "actionStatsNA mt12p"
                : "actionStatsNA"
            }
          >
            {" "}
            No Action status{" "}
          </div>
          <p className={isDashboardPage ? "" : "actionStatsNAsubtitle"}>
            {" "}
            on {isAllEOPage ? "objectives" : "this objective"}
          </p>
        </span>
      );
    } else {
      return <span>Loading...</span>;
    }
  }
}

export default ActionsPieChart;
